module.exports = __webpack_public_path__ + "img/115.fbcca1b1.jpg";